/* ── ISEKAI Bundle Page — assets/bundle.js ─────────────────────── */

const FITTED = {
  'forevergreen': {
    double: { id: '42340916232288', price: 130 }, queen: { id: '42340916265056', price: 150 }, king: { id: '42340916297824', price: 170 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Forevergreen_fitted1.png?v=1750312348'
  },
  'goldie': {
    double: { id: '42340917510240', price: 130 }, queen: { id: '42340917543008', price: 150 }, king: { id: '42340917575776', price: 170 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Goldie_fitted1.png?v=1738228449'
  },
  'whisper-pink': {
    double: { id: '42340923244640', price: 130 }, queen: { id: '42340923277408', price: 150 }, king: { id: '42340923310176', price: 170 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_Fitted1.png?v=1759835586'
  },
};
const FLAT = {
  'forevergreen': {
    double: { id: '42340932255840', price: 120 }, queen: { id: '42340932288608', price: 140 }, king: { id: '42340932321376', price: 160 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Forevergreen_flat1.png?v=1738228643'
  },
  'goldie': {
    double: { id: '42340930814048', price: 120 }, queen: { id: '42340930846816', price: 140 }, king: { id: '42340930879584', price: 160 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Goldie_flat1.png?v=1738228516'
  },
  'whisper-pink': {
    double: { id: '42340926226528', price: 120 }, queen: { id: '42340926259296', price: 140 }, king: { id: '42340926292064', price: 160 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_flat1.png?v=1759483999'
  },
};
const DUVET = {
  'forevergreen': {
    double: { id: '42337771028576', price: 210 }, queen: { id: '42337771061344', price: 230 }, king: { id: '42337771094112', price: 250 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Forevergreen_duvet2.png?v=1740651812'
  },
  'goldie': {
    double: { id: '42337821982816', price: 210 }, queen: { id: '42337822015584', price: 230 }, king: { id: '42337822048352', price: 250 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Goldie_duvet1.png?v=1738228401'
  },
  'whisper-pink': {
    double: { id: '42337828143200', price: 210 }, queen: { id: '42337828175968', price: 230 }, king: { id: '42337828208736', price: 250 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_Duvet1.png?v=1759473466'
  },
};
const PILLOWCASES = {
  'forevergreen': {
    '2x': { id: '42340940709984', price: 75 }, '4x': { id: '42340940742752', price: 150 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Forevergreen_pillow1.png?v=1738228689'
  },
  'goldie': {
    '2x': { id: '42340934516832', price: 75 }, '4x': { id: '42340934549600', price: 150 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Goldie_pillowcases1.png?v=1737355303'
  },
  'whisper-pink': {
    '2x': { id: '42340938842208', price: 75 }, '4x': { id: '42340938874976', price: 150 },
    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_Pillow1.png?v=1759835586'
  },
};
const VASE = {
  'pavlova-small':    { id: '42417702862944',  price: 85,  label: 'Pavlova Bloom Small',   handle: 'isekai-pavlova-bloom-small-vase',    img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/WavyTallPGC2_3000x_a64ad45e-541c-4f0d-894e-ac6ad1ae64ff.webp' },
  'pavlova-medium':   { id: '42417702797408',  price: 120, label: 'Pavlova Bloom Medium',  handle: 'isekai-pavlova-bloom-medium-vase',   img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/WavyLargePGC2_3000x_594cadb2-6d03-439d-941e-27f52ae111be.webp' },
  'nuclassic-small':  { id: '42467953967200',  price: 85,  label: 'NuClassic Small',        handle: 'isekai-small-nuclassic',             img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/A_0036s_0000_NCSPGG4_jpg_3000x_a19e6ff4-c1cc-4835-bf39-1f5c9016a8ff.webp?v=1781003428' },
  'nuclassic-medium': { id: '42450926207072',  price: 120, label: 'NuClassic Medium',       handle: 'isekai-medium-nuclassic',            img: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/A_0052s_0000_NCMPGC4_jpg_3000x_30620fb3-ef87-4279-9070-e9fa1febeac0.webp?v=1781003461' },
};
const VASE_STOCK = {};

const SELECTOR_IMAGES = {
  fitted: {
    'forevergreen': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_Forevergreen_Fitted3.png?v=1776347485',
    'goldie':       'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_GoldieYellow_Fitted4.png?v=1769989057',
    'whisper-pink': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_Fitted3.png?v=1759483999',
  },
  flat: {
    'forevergreen': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_Forevergreen_flat4.png?v=1776347485',
    'goldie':       'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_GoldieYellow_flat4.png?v=1759834460',
    'whisper-pink': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_flat4.png?v=1769989057',
  },
  duvet: {
    'forevergreen': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group5247.png?v=1769989057',
    'goldie':       'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group5218.png?v=1769989057',
    'whisper-pink': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group_5213.png?v=1769989057',
  },
  pillowcases: {
    'forevergreen': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_Forevergreen_Pillow4.png?v=1776347485',
    'goldie':       'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_GoldieYellow_Pillow2.png?v=1759835165',
    'whisper-pink': 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_WhisperPink_Pillow2.png?v=1759835586',
  },
};

const DISCOUNT_CODE       = 'ISEKAI15';
const DISCOUNT_PERCENT    = 0.15;
const DISCOUNT_MIN_QTY    = 3; // fitted + duvet + pillowcases = 3 required items

const state = {
  fitted:           { colour: null, size: null },
  flat:             { colour: null, size: null, enabled: false },
  duvet:            { colour: null, size: null },
  pillowcases:      { colour: null, qty: '2x' },
  vase:             { size: null, enabled: true },
  bundlesRemaining: null,
};

/* ── Pricing ──────────────────────────────────────────────────────── */
function calcPricing() {
  let beddingTotal = 0;
  let itemCount = 0;

  if (state.fitted.colour && state.fitted.size) {
    beddingTotal += FITTED[state.fitted.colour][state.fitted.size].price;
    itemCount++;
  }
  if (state.flat.enabled && state.flat.colour && state.flat.size) {
    beddingTotal += FLAT[state.flat.colour][state.flat.size].price;
  }
  if (state.duvet.colour && state.duvet.size) {
    beddingTotal += DUVET[state.duvet.colour][state.duvet.size].price;
    itemCount++;
  }
  if (state.pillowcases.colour) {
    beddingTotal += PILLOWCASES[state.pillowcases.colour][state.pillowcases.qty].price;
    itemCount++;
  }

  let vaseTotal = 0;
  if (state.vase.enabled && state.vase.size) {
    vaseTotal += VASE[state.vase.size].price;
  }

  const grandTotal = beddingTotal + vaseTotal;
  const discountEligible = itemCount >= DISCOUNT_MIN_QTY;
  // ISEKAI15 applies 15% off the entire bundle, including the vase.
  const discountAmt = discountEligible ? Math.round(grandTotal * DISCOUNT_PERCENT * 100) / 100 : 0;
  const total = grandTotal - discountAmt;

  return { grandTotal, discountAmt, total, discountEligible };
}

function isReady() {
  const fittedOk = state.fitted.colour && state.fitted.size;
  const duvetOk  = state.duvet.colour  && state.duvet.size;
  const pcOk     = state.pillowcases.colour;
  const flatOk   = !state.flat.enabled || (state.flat.colour && state.flat.size);
  const vaseOk   = !state.vase.enabled || (state.vase.size && (VASE_STOCK[state.vase.size] === undefined || VASE_STOCK[state.vase.size] > 0));
  return !!(fittedOk && duvetOk && pcOk && flatOk && vaseOk);
}

/* ── Render ───────────────────────────────────────────────────────── */
function renderPricing() {
  const { grandTotal, discountAmt, total, discountEligible } = calcPricing();
  const fmt = (v) => `$${v.toFixed(2).replace(/\.00$/, '')}`;

  document.getElementById('bundle-subtotal-val').textContent = grandTotal > 0 ? fmt(grandTotal) : '—';
  document.getElementById('bundle-total-val').textContent    = grandTotal > 0 ? fmt(total)      : '—';

  const discRow = document.getElementById('bundle-discount-row');
  const discVal = document.getElementById('bundle-discount-val');
  if (discountEligible && discountAmt > 0) {
    discRow.style.display = '';
    discVal.textContent = `−${fmt(discountAmt)}`;
  } else {
    discRow.style.display = 'none';
  }

  const notice = document.getElementById('bundle-discount-notice');
  notice.style.display = discountEligible ? '' : 'none';

  // Afterpay
  const afterpay = document.getElementById('bundle-afterpay');
  if (total > 0) {
    const installment = (total / 4).toFixed(2);
    afterpay.innerHTML = `or 4 payments of <strong>$${installment}</strong> with Afterpay`;
  } else {
    afterpay.textContent = '';
  }

  // Mobile sticky bar
  const mobileTotal = document.getElementById('bundle-mobile-total-val');
  const mobileLabel = document.getElementById('bundle-mobile-bar-label');
  if (mobileTotal) mobileTotal.textContent = grandTotal > 0 ? fmt(total) : '—';
  if (mobileLabel) mobileLabel.textContent = discountEligible ? 'Total · 15% off applied' : 'Total';
}

function renderAtc() {
  const ready = isReady();
  document.getElementById('bundle-atc').disabled = !ready;
  const mobileBtn = document.getElementById('bundle-mobile-atc');
  if (mobileBtn) mobileBtn.disabled = !ready;
}

function renderValidation() {
  const msgs = [];
  if (!state.fitted.colour) msgs.push('Select a Fitted Sheet colour');
  else if (!state.fitted.size) msgs.push('Select a Fitted Sheet size');
  if (!state.duvet.colour) msgs.push('Select a Duvet Cover colour');
  else if (!state.duvet.size) msgs.push('Select a Duvet Cover size');
  if (!state.pillowcases.colour) msgs.push('Select a Pillowcases colour');
  if (state.flat.enabled) {
    if (!state.flat.colour) msgs.push('Select a Flat Sheet colour');
    else if (!state.flat.size) msgs.push('Select a Flat Sheet size');
  }
  if (state.vase.enabled && !state.vase.size) msgs.push('Select a Vase size');

  document.getElementById('bundle-validation').textContent = msgs.length ? msgs[0] : '';
}

/* ── Gallery ──────────────────────────────────────────────────────── */
const thumbsEl  = document.getElementById('bundle-thumbs');
const mainImg   = document.getElementById('bundle-main-image');
const mainVid   = document.getElementById('bundle-main-video');
const HERO_SRC  = 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/BedBundle.png?v=1781074594';

// Static media always shown in gallery (images + videos)
const STATIC_MEDIA = [
  { key: 'hero',     type: 'image', src: HERO_SRC },
  { key: 's-isekai', type: 'image', src: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Isekai.png?v=1781093690' },
  { key: 's-img1',  type: 'image', src: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group_5244.png?v=1778378819' },
  { key: 's-vid1',  type: 'video', src: 'https://cdn.shopify.com/videos/c/o/v/3c3157043a3d4b098872961697e452cd.mp4' },
  { key: 's-img4',  type: 'image', src: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group_5218.png?v=1759469986' },
  { key: 's-img5',  type: 'image', src: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group_5672.png?v=1776346022' },
  { key: 's-img7',  type: 'image', src: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/SoonAfter_Forevergreen_Fitted4.png?v=1776347485' },
  { key: 's-img8',  type: 'image', src: 'https://cdn.shopify.com/s/files/1/0592/3569/6736/files/Group_5682.png?v=1776347536' },
];

function showMedia(type, src) {
  if (type === 'video') {
    mainImg.style.display = 'none';
    mainVid.style.display = '';
    if (mainVid.src !== src) {
      mainVid.src = src;
      mainVid.load();
    }
  } else {
    mainVid.pause();
    mainVid.style.display = 'none';
    mainImg.style.display = '';
    mainImg.style.opacity = '0';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.style.opacity = '1';
    }, 180);
  }
}

function updateGallery() {
  // Start with static media, then append colour-specific product images
  const media = [...STATIC_MEDIA];

  const addImg = (key, src) => {
    if (src && !src.includes('undefined')) {
      media.push({ key, type: 'image', src });
    }
  };

  if (state.fitted.colour)                       addImg('fitted', FITTED[state.fitted.colour].img);
  if (state.duvet.colour)                         addImg('duvet',  DUVET[state.duvet.colour].img);
  if (state.flat.enabled && state.flat.colour)    addImg('flat',   FLAT[state.flat.colour].img);
  if (state.pillowcases.colour)                   addImg('pc',     PILLOWCASES[state.pillowcases.colour].img);
  if (state.vase.enabled && state.vase.size)      addImg('vase',   VASE[state.vase.size].img);

  // Keep active key across rebuilds
  const currentActive = thumbsEl.querySelector('.bundle-page__thumb.active');
  const activeKey = currentActive ? currentActive.dataset.imgKey : 'hero';
  thumbsEl.innerHTML = '';

  media.forEach((item) => {
    const div = document.createElement('div');
    div.className = 'bundle-page__thumb' + (item.key === activeKey ? ' active' : '');
    div.dataset.imgKey = item.key;

    if (item.type === 'video') {
      div.classList.add('is-video');
      div.innerHTML = `
        <video src="${item.src}" muted preload="metadata" playsinline style="width:100%;height:100%;object-fit:cover;pointer-events:none;"></video>
        <span class="bundle-thumb__play" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" fill="rgba(0,0,0,0.45)"/><polygon points="8,6.5 15,10 8,13.5" fill="#fff"/></svg>
        </span>`;
    } else {
      div.innerHTML = `<img src="${item.src}" alt="" loading="lazy">`;
    }

    div.addEventListener('click', () => {
      thumbsEl.querySelectorAll('.bundle-page__thumb').forEach(t => t.classList.remove('active'));
      div.classList.add('active');
      showMedia(item.type, item.src);
    });
    thumbsEl.appendChild(div);
  });
}

/* ── Swatch helpers ────────────────────────────────────────────────── */
function bindSwatches(selectorEl, stateProp, colourLabelId, imgId) {
  selectorEl.querySelectorAll('.bundle-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      selectorEl.querySelectorAll('.bundle-swatch').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state[stateProp].colour = btn.dataset.colour;
      const label = document.getElementById(colourLabelId);
      if (label) label.textContent = `: ${btn.title}`;
      // Update selector thumbnail image
      if (imgId && SELECTOR_IMAGES[stateProp]) {
        const img = document.getElementById(imgId);
        const src = SELECTOR_IMAGES[stateProp][btn.dataset.colour];
        if (img && src) img.src = src;
      }
      renderAll();
      updateGallery();
    });
  });
}

function bindSizeButtons(containerSelector, stateProp) {
  document.querySelectorAll(`${containerSelector} .bundle-size-btn`).forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll(`${containerSelector} .bundle-size-btn`).forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state[stateProp].size = btn.dataset.size;
      renderAll();
    });
  });
}

function bindQtyButtons(containerEl, stateProp) {
  containerEl.querySelectorAll('.bundle-size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      containerEl.querySelectorAll('.bundle-size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state[stateProp].qty = btn.dataset.qty;
      renderAll();
    });
  });
}

function bindToggle(toggleId, contentId, stateProp) {
  const toggleBtn = document.getElementById(toggleId);
  const content   = document.getElementById(contentId);
  if (!toggleBtn || !content) return;
  toggleBtn.addEventListener('click', () => {
    const on = !state[stateProp].enabled;
    state[stateProp].enabled = on;
    toggleBtn.classList.toggle('active', on);
    toggleBtn.setAttribute('aria-pressed', String(on));
    content.classList.toggle('open', on);
    renderAll();
    updateGallery();
  });
}

function renderAll() {
  renderPricing();
  renderAtc();
  renderValidation();
}

/* ── Care Guide ───────────────────────────────────────────────────── */
function initCareGuide() {
  const btn     = document.getElementById('care-guide-toggle');
  const content = document.getElementById('care-guide-content');
  const icon    = document.getElementById('care-guide-icon');
  if (!btn) return;
  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    content.style.display = expanded ? 'none' : '';
    icon.textContent = expanded ? '+' : '—';
  });
}

/* ── Isekai gallery lightbox ──────────────────────────────────────── */
function initIsekaiLightbox() {
  const lightbox    = document.getElementById('isekai-lightbox');
  const lightboxImg = document.getElementById('isekai-lightbox-image');
  const closeBtn    = document.getElementById('isekai-lightbox-close');
  if (!lightbox || !lightboxImg || !closeBtn) return;

  const closeLightbox = () => {
    lightbox.classList.remove('open');
    lightboxImg.src = '';
  };

  document.querySelectorAll('.isekai-gallery-img').forEach(img => {
    img.addEventListener('click', () => {
      lightboxImg.src = img.src;
      lightboxImg.alt = img.alt;
      lightbox.classList.add('open');
    });
  });

  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
  });
}

/* ── Tabs ─────────────────────────────────────────────────────────── */
function initTabs() {
  document.querySelectorAll('.bundle-tabs__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.bundle-tabs__btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.bundle-tabs__panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      const panel = document.getElementById(btn.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });
}

/* ── Vase stock ─────────────────────────────────────────────────────── */
async function loadVaseStock() {
  await Promise.all(Object.entries(VASE).map(async ([key, v]) => {
    try {
      const res  = await fetch(`/products/${v.handle}.json`);
      const data = await res.json();
      const variant = data.product.variants.find(vr => String(vr.id) === v.id);
      VASE_STOCK[key] = variant ? variant.inventory_quantity : 0;
    } catch (e) {
      VASE_STOCK[key] = 99; // fail open
    }
  }));
  document.querySelectorAll('.bundle-vase-option').forEach(opt => {
    const size  = opt.dataset.vaseSize;
    const qty   = VASE_STOCK[size];
    const badge = opt.querySelector('.vase-soldout');
    if (qty !== undefined && qty <= 0) {
      opt.classList.add('is-sold-out');
      if (badge) badge.style.display = '';
      if (state.vase.size === size) {
        state.vase.size = null;
        opt.classList.remove('active');
        const radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
      }
    } else {
      opt.classList.remove('is-sold-out');
      if (badge) badge.style.display = 'none';
    }
  });
  renderAll();
}

/* ── Add to Cart ─────────────────────────────────────────────────── */
async function addToCart() {
  if (!isReady()) return;
  const buttons = [document.getElementById('bundle-atc'), document.getElementById('bundle-mobile-atc')].filter(Boolean);
  buttons.forEach(btn => {
    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.textContent = 'Adding…';
  });

  const items = [];

  // Fitted sheet
  const fittedVariant = FITTED[state.fitted.colour][state.fitted.size];
  items.push({ id: fittedVariant.id, quantity: 1 });

  // Flat sheet
  if (state.flat.enabled && state.flat.colour && state.flat.size) {
    items.push({ id: FLAT[state.flat.colour][state.flat.size].id, quantity: 1 });
  }

  // Duvet cover
  const duvetVariant = DUVET[state.duvet.colour][state.duvet.size];
  items.push({ id: duvetVariant.id, quantity: 1 });

  // Pillowcases
  items.push({ id: PILLOWCASES[state.pillowcases.colour][state.pillowcases.qty].id, quantity: 1 });

  // Vase
  if (state.vase.enabled && state.vase.size) {
    items.push({ id: VASE[state.vase.size].id, quantity: 1 });
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error('Cart error');
    window.location.href = `/discount/${DISCOUNT_CODE}?redirect=/cart`;
  } catch (err) {
    buttons.forEach(btn => {
      btn.textContent = 'Something went wrong — try again';
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
    setTimeout(() => {
      buttons.forEach(btn => { btn.textContent = btn.dataset.originalText; });
      renderAtc();
    }, 3000);
  }
}

/* ── Vase selector ────────────────────────────────────────────────── */
function initVaseOptions() {
  document.querySelectorAll('.bundle-vase-option').forEach(opt => {
    opt.addEventListener('click', () => {
      document.querySelectorAll('.bundle-vase-option').forEach(o => {
        o.classList.remove('active');
        o.querySelector('input[type="radio"]').checked = false;
      });
      if (opt.classList.contains('is-sold-out')) return;
      opt.classList.add('active');
      opt.querySelector('input[type="radio"]').checked = true;
      state.vase.size = opt.dataset.vaseSize;
      updateGallery();
      renderAll();
    });
  });
}

/* ── Mobile bar scroll trigger ────────────────────────────────────── */
function initMobileBarScroll() {
  const bar = document.getElementById('bundle-mobile-bar');
  if (!bar) return;

  // Detect theme sticky header height to offset bar below it
  function getHeaderOffset() {
    const candidates = [
      'sticky-header',
      '.header-wrapper',
      '.site-header',
      '#shopify-section-header',
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) {
        const style = getComputedStyle(el);
        if (style.position === 'sticky' || style.position === 'fixed') {
          return el.offsetHeight;
        }
      }
    }
    return 0;
  }

  const headerOffset = getHeaderOffset();
  bar.style.top = headerOffset + 'px';

  const update = () => {
    bar.classList.toggle('is-visible', window.scrollY > 300);
  };
  window.addEventListener('scroll', update, { passive: true });
  update();
}

/* ── Init ─────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  // Swatches (last param = selector thumbnail image id)
  bindSwatches(document.getElementById('bundle-fitted'),      'fitted',      'fitted-colour-label',      'fitted-product-img');
  bindSwatches(document.getElementById('bundle-flat'),        'flat',        'flat-colour-label',        'flat-product-img');
  bindSwatches(document.getElementById('bundle-duvet'),       'duvet',       'duvet-colour-label',       'duvet-product-img');
  bindSwatches(document.getElementById('bundle-pillowcases'), 'pillowcases', 'pillowcases-colour-label', 'pillowcases-product-img');

  // Per-product size buttons
  bindSizeButtons('.bundle-fitted-size', 'fitted');
  bindSizeButtons('.bundle-flat-size',   'flat');
  bindSizeButtons('.bundle-duvet-size',  'duvet');

  // Pillowcase quantity
  bindQtyButtons(document.getElementById('pillowcases-qty-btns'), 'pillowcases');

  // Optional toggles
  bindToggle('flat-toggle',  'flat-content',  'flat');
  bindToggle('vase-toggle',  'vase-content',  'vase');

  // Vase options
  initVaseOptions();

  // Tabs + care guide
  initTabs();
  initCareGuide();

  // Isekai gallery lightbox
  initIsekaiLightbox();

  // ATC
  document.getElementById('bundle-atc').addEventListener('click', addToCart);
  const mobileAtcBtn = document.getElementById('bundle-mobile-atc');
  if (mobileAtcBtn) mobileAtcBtn.addEventListener('click', addToCart);

  // Vase stock
  loadVaseStock();

  // Mobile bar scroll trigger
  initMobileBarScroll();

  // Initial render
  renderAll();
  updateGallery();
});